import * as Vest from 'vest';

export const FormSuite = Vest.create((data = {}) => {
    Vest.test('MonthlyAmount', 'ERROR_AMOUNT_NET', () => {
        if(data?.NetToBrutCheck == true)
        {
            Vest.enforce(data.MonthlyAmount).allOf(Vest.enforce.greaterThan(0), Vest.enforce.lessThanOrEquals(3000000));
        }
        else
        {
            return true;
        }
    });

    Vest.test('MonthlyAmount', 'ERROR_AMOUNT_BRUT', () => {
        if(data?.NetToBrutCheck == false)
        {
            Vest.enforce(data.MonthlyAmount).allOf(Vest.enforce.greaterThan(0), Vest.enforce.lessThanOrEquals(7000000));
        }
        else
        {
            return true;
        }
    });
    
    Vest.test('GroupInsurance', 'ERROR_MUST_GTE_0', () => {
        Vest.enforce(data.GroupInsurance).greaterThanOrEquals(0);
        return true;
    });
});